(function () {
  function initializeMap(root) {
    if (!window.L || root.dataset.mapInitialized === 'true') return;

    var canvas = root.querySelector('[data-contact-leaflet-canvas]');
    var latitude = Number.parseFloat(root.dataset.mapLatitude);
    var longitude = Number.parseFloat(root.dataset.mapLongitude);
    var zoom = Number.parseInt(root.dataset.mapZoom, 10) || 13;
    var label = root.dataset.mapLabel || "Unique'e Luxury";

    if (!canvas || !Number.isFinite(latitude) || !Number.isFinite(longitude)) return;

    root.dataset.mapInitialized = 'true';

    var map = window.L.map(canvas, {
      scrollWheelZoom: false,
      zoomControl: true
    }).setView([latitude, longitude], zoom);

    window.L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 19,
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    }).addTo(map);

    window.L.circleMarker([latitude, longitude], {
      radius: 8,
      color: '#9d7a3f',
      weight: 2,
      fillColor: '#d7b36d',
      fillOpacity: 1
    }).addTo(map).bindPopup(label).openPopup();
  }

  function initializeAll(scope) {
    (scope || document).querySelectorAll('[data-contact-leaflet]').forEach(initializeMap);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initializeAll(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initializeAll(event.target);
  });
})();
